import ScalarMenuLink_default from "./ScalarMenuLink.vue.js";
import ScalarMenuSection_default from "./ScalarMenuSection.vue.js";
import { createBlock, createTextVNode, createVNode, defineComponent, openBlock, unref, withCtx } from "vue";
import { ScalarIconBookOpenText, ScalarIconEnvelopeSimple, ScalarIconFileText } from "@scalar/icons";
var ScalarMenuResources_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ScalarMenuResources",
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(ScalarMenuSection_default, null, {
				title: withCtx(() => [..._cache[0] || (_cache[0] = [createTextVNode("Resources", -1)])]),
				default: withCtx(() => [
					createVNode(ScalarMenuLink_default, {
						href: "mailto:support@scalar.com",
						icon: unref(ScalarIconEnvelopeSimple),
						target: "_blank"
					}, {
						default: withCtx(() => [..._cache[1] || (_cache[1] = [createTextVNode(" Sales & Support ", -1)])]),
						_: 1
					}, 8, ["icon"]),
					createVNode(ScalarMenuLink_default, {
						href: "https://scalar.com/terms-and-conditions",
						icon: unref(ScalarIconFileText),
						target: "_blank"
					}, {
						default: withCtx(() => [..._cache[2] || (_cache[2] = [createTextVNode(" Terms & Conditions ", -1)])]),
						_: 1
					}, 8, ["icon"]),
					createVNode(ScalarMenuLink_default, {
						href: "https://scalar.com/privacy-policy",
						icon: unref(ScalarIconBookOpenText),
						target: "_blank"
					}, {
						default: withCtx(() => [..._cache[3] || (_cache[3] = [createTextVNode(" Privacy Policy ", -1)])]),
						_: 1
					}, 8, ["icon"])
				]),
				_: 1
			});
		};
	}
});
//#endregion
export { ScalarMenuResources_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarMenuResources.vue_vue_type_script_setup_true_lang.js.map